/**
 *
 * @module reauthorizationFailure
 *
 */

import Token from './token/entry';

/**
 *
 * @class ReauthorizationFailure
 * @extends {SDK.Token.TokenRefreshFailure}
 * @desc The event raised when automatic token refresh fails.
 *
 */
export default class ReauthorizationFailure extends Token.TokenRefreshFailure {}



// WEBPACK FOOTER //
// ./src/reauthorizationFailure.js